import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { InstallationFeaturesStore } from '@store';
import {
  FanRingCondensatePan,
  FeatureCommands,
  FeatureNames,
  FeaturePropertyKey,
} from '@vi-iot/client/index';

@Component({
  selector: 'app-fan-ring-condensate-pan-heater',
  templateUrl: './fan-ring-condensate-pan-heater.component.html',
  styleUrls: ['./fan-ring-condensate-pan-heater.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FanRingCondensatePanHeaterComponent {
  @Input() fanRingFeature: FanRingCondensatePan;
  public featureNames = FeatureNames;

  constructor(private installationFeaturesStore: InstallationFeaturesStore) {}

  switchFeature(event, featureName: string): void {
    this.installationFeaturesStore.updateFeature(
      featureName,
      null,
      FeaturePropertyKey.active,
      null,
      event.checked ? FeatureCommands.activate : FeatureCommands.deactivate
    );
  }
}
